import { Component } from '@angular/core';

@Component({
  selector: 'resource-center-tab',
  templateUrl: './resource-center-tab.component.html',
  styleUrl: './resource-center-tab.component.scss',
  standalone: false,
})
export class ResourceCenterTabComponent {}
